import React, { Component } from 'react'
import $ from 'jquery'
import Pagination from './Pagination.jsx';
import { apiClient } from "../helpers/common";
import swal from 'sweetalert';

class Orders extends Component {

    constructor(props) {
        super(props);
        this.state = {
            totalRecords: 0,
            totalItems: [],
            pageOfItems: [],
            showPagination: false,
            pageSize: 20,
            name: '',
            phone: '',
            user_id: '',
            totalOrders:[]
        };
    }
    componentDidMount() {

        if (sessionStorage.getItem('adminDetails') !== undefined && sessionStorage.getItem('adminDetails') !== null) {
            this.getOrdersList();
        } else {
            window.location.replace("/admin-login");
        }
    }
    componentDidUpdate() {

    }
    onChangePage = (items) => {
        this.setState({ pageOfItems: items });
    }
    getOrdersList = async () => {
        let postData = {
            token: JSON.parse(sessionStorage.getItem('adminDetails')).token,
        }

        const result = await apiClient('orders-list', {
            method: 'POST',
            body: postData
        });

        if (result.status === 200) {
            let pagination =  result.data.length > 10 ? true :false
            this.setState({ totalItems: result.data, totalRecords: result.data.length ,showPagination:pagination})
        } 
    }
    
    showProducts =async(id)=>{
     
        let postData = {
            orderuuid: id,

        }

        const result = await apiClient('admin-orders-detail', {
            method: 'POST',
            body: postData
        });

        if (result.status === 200) {
            this.setState({ totalOrders: result.data},()=>{
                window.$("#showOrdersPopup").modal("show")
            })
        } 
    }

    orderListing = (data) => {
        if (data && data.length) {
            return (
                data.map((val, i) => {
                    return (
                       
                        <tr key={i + 1} >
                            <td>{val.orderid}</td>
                            <td style={{ width: '10%' }}>{val.created_at}</td>
                            <td style={{ width: '10%' }}><a href="javascript:void(0)" onClick={(e)=>this.showProducts(val.ordersuuid)} >{val.TotalProducts}</a></td>
                            <td style={{ width: '10%' }}>{val.amount}</td>
                            <td style={{ width: '10%' }}>{val.delivery_amount}</td>
                            <td style={{ width: '10%' }}>{val.username}</td>
                      
                             <td>

                             {
                                    val.status === 'C' ? 'Completed': val.status === 'P' ? 'Pending' :val.status ==='F'  ? 'Failed' :''
                                }
                            </td>
                        </tr>
                    )
                })
            )
        }
    }
    filterData = (e,key) => {

        let updatedList = this.state.totalItems;
        updatedList = this.state.totalItems.filter((val) => {
            if(e.target.value !== ''){
                if(val[key] !== null){
                    if(key === 'age'){
                        return val[key].toString().search(e.target.value) !== -1 ;
                    }else{
                        return val[key].toLowerCase().search(e.target.value.toLowerCase()) !== -1 ;
                    }
                
                }
            }else{
                return val
            }
        });
       
        this.setState({ 
            pageOfItems: updatedList.slice(0, 10),
            showPagination:updatedList.length > 10 ? true:false 
        });
    }
    render() {
        const { pageSize,totalOrders } = this.state
        return (<>
            <div className="page_content">
                <section className="upper_section">
                    <div className="page_heading row">
                        <h3><span className="title">Orders</span></h3>
                        <div className="page_actions">

                        </div>
                    </div>
                </section>
                <section className="lower_section">
                    <div className="row">
                        <div className="col-md-12 table-responsive  mt-3">
                            <div className="container-fluid bg-white p-0 mb-15 pb-0">
                                <table className="table table-striped table-bordered mb-0">
                                    <thead>
                                        <tr>
                                            <th>Order ID</th>
                                            <th style={{ width: '10%' }}>Order Date</th>
                                            <th style={{ width: '10%' }}>Total Products</th>
                                            <th style={{ width: '10%' }}>Amount</th>
                                            <th style={{ width: '5%' }}>Delivery Amount</th>
                                            <th style={{ width: '10%' }}>Ordered By</th>
                                          
                                            <th>Status</th>
                                         
                                        </tr>
                                    </thead>
                                    <tbody>
                                       {/* <tr>
                                           
                                            <td style={{ width: '10%' }}><input type="text" onChange={(e)=>this.filterData(e,'name')} className="form-control" /></td>
                                            <td style={{ width: '10%' }}><input type="text" onChange={(e)=>this.filterData(e,'phone')} className="form-control" /></td>
                                            <td style={{ width: '5%' }}><input type="text" onChange={(e)=>this.filterData(e,'country')} className="form-control" /></td>
                                            <td style={{ width: '10%' }}><input type="text" onChange={(e)=>this.filterData(e,'type')} className="form-control" /></td>
                                            <td style={{ width: '10%' }}></td>
                                            <td style={{ width: '10%' }}></td>
                                        </tr> */}
                                        {this.orderListing(this.state.pageOfItems)}
                                    </tbody>
                                </table>
                                

                            </div>
                        </div>
                        <div className="col-md-12 pt-3 pagingWrap pb-3">
                            <div className="row">
                                {this.state.totalRecords > 0  ? <Pagination items={this.state.totalItems} onChangePage={this.onChangePage} /> : ''}
                            </div>
                        </div>
                    </div>
                </section>
            </div>

              {/*Show orders*/}
              <div className="modal fade smallmodalwrap " id="showOrdersPopup" tabIndex="-1" role="dialog" data-keyboard="false" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog smallmodal" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                       <h5 className="modal-title capcase mr-auto ng-binding">Products</h5>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12">
                                <div className="col-md-12 table-responsive  mt-3">
                                    <div className="container-fluid bg-white p-0 mb-15 pb-0">
                                        <table className="table table-striped table-bordered mb-0">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '10%' }}>Product Name</th>
                                                    <th style={{ width: '10%' }}>Price</th>
                                                    <th style={{ width: '10%' }}>Quantity</th>
                                                    <th style={{ width: '10%' }}>Seller</th>
                                                    <th style={{ width: '10%' }}>Store</th>
                                                    {/* <th style={{ width: '10%' }}>Order Status</th> */}
                                             
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    totalOrders.length > 0 && totalOrders.map((product,key)=>{

                                                        return( <>
                                                             <tr key={key+1}>
                                                                 <td>{product.name}</td>
                                                                 <td>{product.totalprice}</td>
                                                                 <td>{product.quantity}</td>
                                                                 <td>{product.sellerName}</td>
                                                                 <td>{product.storeName}</td>
                                                                 {/* <td>{product.delivery_status}</td> */}
                                                             </tr>
                                                            </>
                                                        )
                                                    })
                                                }
                                              
                                            </tbody>
                                        </table>
                                        

                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer"></div>
                    </div>
                </div>
            </div>

           
        </>)
    }
}
export default Orders